import { useState, useEffect } from "react";
import { FaUserFriends, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./TrainingCoopSection.css";

import img1 from "../../../assets/imgs/home/training-coop/ht1.jpg";
import img2 from "../../../assets/imgs/home/training-coop/ht2.jpg";
import img3 from "../../../assets/imgs/home/training-coop/ht3.jpg";
import img4 from "../../../assets/imgs/home/training-coop/ht4.jpg";
import img5 from "../../../assets/imgs/home/training-coop/ht5.jpg";
import img6 from "../../../assets/imgs/home/training-coop/ht6.jpg";
import img7 from "../../../assets/imgs/home/training-coop/ht7.jpg";
import img8 from "../../../assets/imgs/home/training-coop/ht8.jpg";
import img9 from "../../../assets/imgs/home/training-coop/ht9.jpg";
import img10 from "../../../assets/imgs/home/training-coop/ht10.jpg";
import img11 from "../../../assets/imgs/home/training-coop/ht11.jpg";
import img12 from "../../../assets/imgs/home/training-coop/ht12.jpg";
import img13 from "../../../assets/imgs/home/training-coop/ht13.jpg";
import img14 from "../../../assets/imgs/home/training-coop/ht14.jpg";
import img15 from "../../../assets/imgs/home/training-coop/ht15.jpg";
import img16 from "../../../assets/imgs/home/training-coop/ht16.jpg";
import img17 from "../../../assets/imgs/home/training-coop/ht17.jpg";
import img18 from "../../../assets/imgs/home/training-coop/ht18.jpg";

const trainingImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
];

const TrainingCoopSection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden"; // khóa scroll background khi mở
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = ""; // mở lại scroll
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) =>
      prev === 0 ? trainingImages.length - 1 : prev - 1
    );
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) =>
      prev === trainingImages.length - 1 ? 0 : prev + 1
    );
  };

  // Bắt phím ESC, mũi tên trái/phải khi lightbox mở
  useEffect(() => {
    if (!lightboxOpen) return;

    const handleKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      else if (e.key === "ArrowLeft")
        setCurrentIndex((prev) =>
          prev === 0 ? trainingImages.length - 1 : prev - 1
        );
      else if (e.key === "ArrowRight")
        setCurrentIndex((prev) =>
          prev === trainingImages.length - 1 ? 0 : prev + 1
        );
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightboxOpen]);

  return (
    <section className="training-coop">
      <div className="training-coop__container">
        <div className="training-coop__icon">
          <FaUserFriends />
        </div>
        <h2 className="training-coop__title">CÁC HOẠT ĐỘNG HỢP TÁC ĐÀO TẠO</h2>

        <div className="training-coop__grid">
          {trainingImages.map((img, index) => (
            <div
              key={index}
              className="training-coop__item"
              onClick={() => openLightbox(index)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && openLightbox(index)}
            >
              <img
                src={img}
                alt={`Hoạt động ${index + 1}`}
                className="training-coop__img"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {lightboxOpen && (
        <div
          className="lightbox"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label="Lightbox hình ảnh"
        >
          <button
            className="lightbox__close"
            onClick={closeLightbox}
            aria-label="Đóng"
          >
            &times;
          </button>
          <button
            className="lightbox__nav lightbox__prev"
            onClick={prevImage}
            aria-label="Hình trước"
          >
            <FaChevronLeft />
          </button>
          <img
            src={trainingImages[currentIndex]}
            alt={`Hoạt động ${currentIndex + 1}`}
            className="lightbox__img"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="lightbox__nav lightbox__next"
            onClick={nextImage}
            aria-label="Hình kế tiếp"
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </section>
  );
};

export default TrainingCoopSection;
